import React from "react";
import { cn } from "@/lib/utils";

interface VerticalDividerProps {
  className?: string;
  heightClassName?: string;
}

const VerticalDivider: React.FC<VerticalDividerProps> = ({
  className,
  heightClassName = "h-6",
}) => {
  return <div className={cn(heightClassName, "w-px bg-dark-green", className)} />;
};

export default VerticalDivider;
